// extracted by mini-css-extract-plugin
export default {"uploadDocuments":"UploadDocuments-module__uploadDocuments--kBSsQ","card":"UploadDocuments-module__card--DP_dq","cardContent":"UploadDocuments-module__cardContent--lDufe"};